import { searchPromotedEvents } from '@eventbrite/api-clients';
import { transformDestinationEvent } from '@eventbrite/event-renderer';
import { useQuery } from '@tanstack/react-query';
import { transformToPromotedEventSearchApiPayload } from '../../../../api/searchAllEvents';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { Location } from '../../../../types/index';
import { useBaseSearchQuery } from './events';
export function usePromotedEvent({
    search = {},
    enabled,
    location,
}: {
    search?: OrganicEventSearchFiltersApiPayload;
    enabled: boolean;
    location: Location;
}) {
    const overloadedQuery = useBaseSearchQuery(search, location);
    const apiPayload = transformToPromotedEventSearchApiPayload({
        slots: 1,
        interfaceName: 'homepage',
        event_search: {
            ...overloadedQuery,
            page: 1,
        },
    });

    const { data: promotedEvents, isLoading: arePromotedEventsLoading } =
        useQuery({
            queryKey: ['homepage', 'promoted', search],
            queryFn: () => searchPromotedEvents(apiPayload),
            staleTime: 0,
            refetchOnMount: true,
            select: (events) => events.map(transformDestinationEvent),
            // Wait until the base query is done loading to enable this
            // follow up one. This will allow for us to not duplicate events
            enabled,
        });

    return {
        promotedEvents,
        arePromotedEventsLoading,
    };
}
